<template>
  <div :class="['box_msg', 'alert', 'flex', otherClass]">
    <div>
      <strong v-html="label" />
      <span class="box_msg--msg" v-html="compileMsg" />
    </div>
    <div v-if="isDeletable" @click="closeEvent()" style="cursor: pointer">
      <i class="fa-light fa-xmark"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'warningMsg',
  props: ['otherClass', 'message', 'label', 'deletable'],
  computed: {
    isDeletable() {
      return this.deletable || false;
    },
    compileMsg() {
      if (this.label) {
        return ': ' + this.message;
      } else {
        return this.message;
      }
    },
  },
  methods: {
    closeEvent() {
      this.$emit('closeEvent');
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: space-between;
}
</style>
